import { render, staticRenderFns } from "./WorkerRegistrationTopNav.vue?vue&type=template&id=64fcde46&scoped=true"
import script from "./WorkerRegistrationTopNav.vue?vue&type=script&lang=js"
export * from "./WorkerRegistrationTopNav.vue?vue&type=script&lang=js"
import style0 from "./WorkerRegistrationTopNav.vue?vue&type=style&index=0&id=64fcde46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fcde46",
  null
  
)

export default component.exports